import { render, staticRenderFns } from "./symptomes.vue?vue&type=template&id=50d93ab9&"
import script from "./symptomes.vue?vue&type=script&lang=js&"
export * from "./symptomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports